import { render, staticRenderFns } from "./ConsolidationDetailUser.vue?vue&type=template&id=0036c0f4&scoped=true"
import script from "./ConsolidationDetailUser.vue?vue&type=script&lang=js"
export * from "./ConsolidationDetailUser.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationDetailUser.vue?vue&type=style&index=0&id=0036c0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036c0f4",
  null
  
)

export default component.exports